<template>
  <div class="diverse-slider-wrapper">
    <v-card class="mx-auto" v-if="slides && slides.length > 0" flat max-width="700px">
      <v-carousel
        :show-arrows="false"
        hide-delimiter-background
        :hide-delimiters="!(slides.length > 1)"
        cycle
        class="rounded-lg carouselClass"
        vertical-delimiters="right"
        vertical
        height="auto">
        <v-carousel-item
          @click="handleClick(slide)"
          v-for="(slide, i) of slides"
          :key="i + '-slide'"
          cover
          aspect-ratio="2.94"
          :data="'https://app.wellcomefit.ch/img/event/1763194046366blob.png'"
          :src="'/img/' + slide.image">
          <v-chip
            v-if="slide.isParty"
            color="primary"
            small
            class="ma-4 white--text font-weight-bold"
            style="position: absolute; top: 0; right: 0; z-index: 2">
            EVENT
          </v-chip>
        </v-carousel-item>
      </v-carousel>
    </v-card>

    <party-overlay v-model="showPartyOverlay" :party="selectedParty" :user="user"></party-overlay>
  </div>
</template>

<script>
import api from "../../api"
import socketService from "@/socketService"
import PartyOverlay from "@/components/home/partyOverlay.vue" // Stelle sicher, dass der Pfad stimmt

export default {
  name: "diverseSlider",
  components: { PartyOverlay },

  data() {
    return {
      loading: true,
      slides: [],
      showPartyOverlay: false,
      selectedParty: null,
      user: JSON.parse(localStorage.getItem("user") || "{}"),
    }
  },

  async created() {
    this.setupSocketListeners()
    await this.loadContent()
    this.loading = false
  },

  beforeDestroy() {
    socketService.off("slide_changed")
    socketService.off("slide_created")
  },

  methods: {
    async loadContent() {
      // 1. EVENTS (Parties) laden
      let parties = []
      try {
        parties = await api.fetchParties() // Diese API Methode hast du vorhin hinzugefügt
        // Parties markieren für Click-Handler & Sortierung
        parties = parties.map((p) => ({ ...p, isParty: true, sort: 0 }))
      } catch (e) {
        console.log("Keine Parties geladen", e)
      }

      // 2. Normale Slides laden
      let standardSlides = [...(await api.fetchEventsForSlider()), ...(await api.fetchMainSlider())]

      // 3. Zusammenfügen (Parties zuerst, oder nach Logik sortieren)
      this.slides = [...parties, ...standardSlides]
    },

    setupSocketListeners() {
      socketService.off("slide_changed")
      socketService.off("slide_created")

      socketService.on("slide_changed", (data) => {
        if (data.slide) this.handleSlideUpdate(data.slide)
      })

      socketService.on("slide_created", (data) => {
        if (data.slide) this.handleSlideUpdate(data.slide)
      })
    },

    handleSlideUpdate(slide) {
      const now = this.$moment()
      const showAfter = this.$moment(slide.showAfter)
      const hideAfter = this.$moment(slide.hideAfter).endOf("day")

      const isActive = now.isSameOrAfter(showAfter) && now.isSameOrBefore(hideAfter)
      const index = this.slides.findIndex((s) => s._id === slide._id)
      const slideExists = index !== -1

      if (slideExists) {
        if (isActive) {
          this.$set(this.slides, index, slide)
        } else {
          this.slides.splice(index, 1)
        }
      } else {
        if (isActive) {
          this.slides.push(slide)
        }
      }
    },

    handleClick(slide) {
      if (slide.isParty) {
        // Wow-Effekt aktivieren
        this.selectedParty = slide
        this.showPartyOverlay = true
      } else {
        // Standard Link-Verhalten
        this.openLink(slide)
      }
    },

    openLink(slide) {
      let link = slide.link || null
      if (link) {
        if (link.includes("http://") || link.includes("https://")) {
          window.open(link, "_blank").focus()
        } else {
          this.$router.push(link)
        }
      }
    },
  },
}
</script>
